import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import $ from 'jquery'
import lightbox from 'lightbox2'
import 'lightbox2/dist/css/lightbox.min.css'
import Sticky from 'sticky-js'

class Actu {
  init () {
    function alaUneSwiper () {
      const swiper = new Swiper('.swiper-a-la-une', {
        modules: [Navigation],
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        loop: true,
        spaceBetween: 15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    }

    function initAsideSticky () {
      // eslint-disable-next-line no-new
      const sticky = new Sticky('.js-aside-actu')
    }

    initAsideSticky()

    function docSelectedSwiper () {
      const swiper = new Swiper('.swiper-doc-selected', {
        modules: [Pagination],
        slidesPerView: 1.1,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination'
        },
        breakpoints: {
          564: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      })
    }

    // Init swipper a la une actualite
    if ($('.swiper-a-la-une').length > 0) {
      alaUneSwiper()
    }

    if ($('.swiper-a-la-une .swiper-slide').length === 0) {
      $('.swiper-a-la-une').hide()
    }

    const element = $('.filter-wrapper')
    if (element.length > 0) {
      const originalPosition = element.offset().top

      $(window).scroll(function () {
        const scroll = $(window).scrollTop()

        if (scroll >= originalPosition) {
          element.addClass('fixed')
        } else {
          element.removeClass('fixed')
        }
      })
    }

    function initFilterSticky () {
      const stickyFilter = new Sticky('.filter-sticky')
    }

    initFilterSticky()

    // Init swipper maillage
    if ($('.gallery-swiper').length > 0) {
      const swiper = new Swiper('.gallery-swiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          564: {
            slidesPerView: 2,
            spaceBetween: 15,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        },
        on: {
          slideChange: function () {
            if (swiper.isEnd) {
              $('.gallery-swiper .via-transparent-right').addClass('hidden')
            } else {
              $('.gallery-swiper .via-transparent-right').removeClass('hidden')
            }

            if (swiper.isBeginning) {
              $('.gallery-swiper .via-transparent-left').addClass('hidden')
            } else {
              $('.gallery-swiper .via-transparent-left').removeClass('hidden')
            }
          }
        }
      })
    }

    lightbox.option({
      resizeDuration: 200,
      wrapAround: true,
      showImageNumberLabel: false,
      disableScrolling: true
    })

    // Init swipper doc selected
    docSelectedSwiper()

    // social share
    if ($('.social-share').length > 0) {
      $('.social-share-link').click(function (e) {
        e.preventDefault()
        const url = $(this).data('url')
        window.open(url, '_blank', 'width=600,height=400')
      })
    }

    // category active
    if ($('.filter')) {
      const allSlide = $('.swiper-slide.all')
      const itemSlides = $('.swiper-slide.item')

      const noneActive = itemSlides.not('.active').length === itemSlides.length

      if (noneActive) {
        allSlide.addClass('active')
      }

      itemSlides.on('click', function () {
        itemSlides.removeClass('active')
        allSlide.removeClass('active')
        $(this).addClass('active')
      })
    }

    if ($('.nav-list-swiper').length > 0) {
      const swiper = new Swiper('.nav-list-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        breakpoints: {
          768: {
            spaceBetween: 10
          }
        }
      })
    }
  }
}

export default Actu
